import {
  faTerminal,
  faSpinner,
  faCheck,
  faExclamationTriangle,
  faBan,
  faClock,
  faFileCode,
} from "@fortawesome/free-solid-svg-icons"
import { faJs, faPython } from "@fortawesome/free-brands-svg-icons"
import { JOB_STATUS, JobStatusResponse } from "types/automation.types"

/**
 * Get appropriate icon for script type
 */
export const getScriptIcon = (script: string) => {
  if (script.endsWith(".bat") || script.endsWith(".cmd")) return faTerminal
  if (script.endsWith(".sh")) return faTerminal
  if (script.endsWith(".js")) return faJs
  if (script.endsWith(".py")) return faPython
  return faFileCode
}

/**
 * Get script type description
 */
export const getScriptType = (script: string): string => {
  if (script.endsWith(".bat") || script.endsWith(".cmd")) return "Batch Script"
  if (script.endsWith(".sh")) return "Shell Script"
  if (script.endsWith(".js")) return "JavaScript"
  if (script.endsWith(".py")) return "Python Script"
  return "Script"
}

/**
 * Get status color for job status
 */
export const getStatusColor = (status: JOB_STATUS): string => {
  switch (status) {
    case JOB_STATUS.QUEUED:
      return "#faad14"
    case JOB_STATUS.RUNNING:
      return "#1890ff"
    case JOB_STATUS.COMPLETED:
      return "#52c41a"
    case JOB_STATUS.FAILED:
      return "#ff4d4f"
    case JOB_STATUS.CANCELLED:
      return "#d9d9d9"
    case JOB_STATUS.TIMEOUT:
      return "#fa8c16"
    default:
      return "#d9d9d9"
  }
}

/**
 * Get status icon for job status
 */
export const getStatusIcon = (status: JOB_STATUS) => {
  switch (status) {
    case JOB_STATUS.QUEUED:
      return faClock
    case JOB_STATUS.RUNNING:
      return faSpinner
    case JOB_STATUS.COMPLETED:
      return faCheck
    case JOB_STATUS.FAILED:
      return faExclamationTriangle
    case JOB_STATUS.CANCELLED:
      return faBan
    case JOB_STATUS.TIMEOUT:
      return faClock
    default:
      return faClock
  }
}

/**
 * Format job status data for console display
 */
export const formatJobStatusForConsole = (
  jobStatus: JobStatusResponse
): string => {
  const output = jobStatus.stdout_output || "No output yet..."
  return output.replace(/\r\n/g, "\n").replace(/\r/g, "\n")
}

/**
 * Check if job is completed (terminal state)
 */
export const isJobCompleted = (status: JOB_STATUS): boolean => {
  return [
    JOB_STATUS.COMPLETED,
    JOB_STATUS.FAILED,
    JOB_STATUS.CANCELLED,
    JOB_STATUS.TIMEOUT,
  ].includes(status)
}

/**
 * Check if job is ongoing (active state)
 */
export const isJobOngoing = (status: JOB_STATUS): boolean => {
  return [JOB_STATUS.QUEUED, JOB_STATUS.RUNNING].includes(status)
}
